import { gql } from "@apollo/client";
import { formatSql } from "../utils/sqlFormatting";

export const QueryWorkItems = gql`
  mutation QueryWorkItems($workItemQuery: workItemQuery!) {
    QueryWorkItems(workItemQuery: $workItemQuery) 
  }
`;

export const QueryWorkItemsForProject = (collectionIds: string[]) => {
  return formatSql`
    SELECT 
        COUNT(CASE WHEN qa_status = 'CQA_COMPLETE' THEN 1 END) AS completed_workitems,
        COUNT(CASE WHEN qa_status = 'IN_CQA' THEN 1 END) AS in_progress_workitems,
        COUNT(CASE WHEN qa_status = 'CQA_APPROVED' THEN 1 END) AS approved_workitems,
        qa_collection_id
    FROM workitem
    WHERE qa_status IN ('IN_CQA', 'CQA_COMPLETE', 'CQA_APPROVED')
        AND qa_collection_id IN (${collectionIds.map(id => `'${id}'`).join(',')})
        AND status = 'ACTIVE'
    GROUP BY qa_collection_id
    ORDER BY qa_collection_id;
  `;
}

export const QueryWorkItemsForProjectPerWorker = (collectionIds: string[], workerId: string) => {
  return formatSql`
    SELECT 
        COUNT(CASE WHEN qa_status = 'CQA_COMPLETE' THEN 1 END) AS completed_workitems,
        COUNT(CASE WHEN qa_status = 'IN_CQA' THEN 1 END) AS in_progress_workitems,
        qa_collection_id
    FROM workitem
    WHERE qa_status IN ('IN_CQA', 'CQA_COMPLETE')
        AND qa_collection_id IN (${collectionIds.map(id => `'${id}'`).join(',')})
        AND status = 'ACTIVE'
        AND assignee = '${workerId}'
    GROUP BY qa_collection_id
    ORDER BY qa_collection_id;
  `;
}

export const QueryWorkItemCountsForMultipleGraders = (workerIds: string[], collectionId: string) => {
    return formatSql`
        SELECT 
            COUNT(CASE WHEN qa_status = 'CQA_COMPLETE' THEN 1 END) AS completed_workitems,
            COUNT(CASE WHEN qa_status = 'IN_CQA' THEN 1 END) AS in_progress_workitems,
            assignee
        FROM workitem
        WHERE assignee IN (${workerIds.map(id => `'${id}'`).join(',')})
            AND qa_status IN ('IN_CQA', 'CQA_COMPLETE')
            AND qa_collection_id = '${collectionId}'
            AND status = 'ACTIVE'
        GROUP BY assignee
        ORDER BY assignee;
    `;
};

// GraphQL mutation for the counts query
export const QueryWorkItemCounts = gql`
  mutation QueryWorkItems($workItemQuery: workItemQuery!) {
    QueryWorkItems(workItemQuery: $workItemQuery) {
      data
      total
    }
  }
`;

// Interface for the response
export interface WorkItemCounts {
    assignee: string;
    completed_workitems: number;
    in_progress_workitems: number;
}